var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"alternateLoginConteiner"},[_c('h1',{staticClass:"primary--text text-center"},[_vm._v(" Estamos te redirecionando para o catálogo. ")]),_c('img',{attrs:{"src":require("@/assets/imgs/bg_alternate-login.svg"),"alt":"background-sagah"}})])
}]

export { render, staticRenderFns }